import {
    faBackwardFast,
    faBackwardStep,
    faForwardFast,
    faForwardStep,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { Table } from "@tanstack/react-table";
import { Button } from "frontend-components";
import { useTranslation } from "react-i18next";

export default function Pagination<T>({ table }: { table: Table<T> }) {
    const { t } = useTranslation();
    const pageCount = Math.max(table.getPageCount(), 1);
    const currentPage = Math.min(table.getState().pagination.pageIndex + 1, pageCount);

    return (
        <div className="mt-4 flex items-center justify-center gap-2 sm:gap-4">
            <Button
                type="button"
                variant="arrow"
                size="arrow"
                onClick={() => table.firstPage()}
                disabled={!table.getCanPreviousPage()}
                aria-label={t("common.firstPage")}
            >
                <FontAwesomeIcon icon={faBackwardFast} />
            </Button>
            <Button
                type="button"
                variant="arrow"
                size="arrow"
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
                aria-label={t("common.previous")}
            >
                <FontAwesomeIcon icon={faBackwardStep} />
            </Button>
            <span className="shrink-0 whitespace-nowrap" aria-live="polite">
                {currentPage} {t("common.of")} {pageCount}
            </span>
            <Button
                type="button"
                variant="arrow"
                size="arrow"
                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}
                aria-label={t("common.next")}
            >
                <FontAwesomeIcon icon={faForwardStep} />
            </Button>
            <Button
                type="button"
                variant="arrow"
                size="arrow"
                onClick={() => table.lastPage()}
                disabled={!table.getCanNextPage()}
                aria-label={t("common.lastPage")}
            >
                <FontAwesomeIcon icon={faForwardFast} />
            </Button>
        </div>
    );
}
